import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

export default function EventBreadcrumb() {
  // const { id } = useParams();

  return (
    <div className="pageBreadcrumb">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/dashboard">Dashboard</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Fintech Masterclass Workshop</Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );
}
